import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: space-between;
`;

export const Actions = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;
